import {Injectable} from "@angular/core";
import {environment} from "@env/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {ShopModel} from "@app/@core/domain/shop.model";
import Shop = ShopModel.Shop;
import ShopListResponse = ShopModel.ShopListResponse;
import PackageImage = ShopModel.ShopImage;
import {map} from "rxjs/operators";
import {orderBy} from "lodash-es";

import {PackageModel} from "@app/@core/domain/package.model";
import PackageStatus = PackageModel.PackageStatus;
import {Repository} from "@app/@core/repositories/repository";


export interface ShopOption {
    label: string;
    value: string;
    status: PackageStatus;
}

@Injectable({
    providedIn: 'root'
})
export class LeisureShopRepository extends Repository<Shop> {

    protected baseURL = environment.api3Url;
    protected path = '/api/internal/shop';

    constructor(protected http: HttpClient) {
      super(http, 'shop');
    }

    getShopList(): Observable<ShopListResponse> {
        return this.http.get<ShopListResponse>(`${this.baseURL + this.path}/list`);
    }

    getShopById(id: string): Observable<Shop> {
        return this.http.get<Shop>(`${this.baseURL + this.path}/${id}`);
    }

    createShop(model: Shop): Observable<Shop> {
        return this.http.post<Shop>(`${this.baseURL + this.path}`, model);
    }

    updateShopById(id: string, model: Shop): Observable<Shop> {
        return this.http.put<Shop>(`${this.baseURL + this.path}/${id}`, model);
    }

    deleteShopById(id: string): Observable<Shop> {
        return this.http.delete<Shop>(`${this.baseURL + this.path}/${id}`);
    }

    saveImages(id: string, images: PackageImage[]): Observable<ShopModel.Shop> {
        return this.http.put<ShopModel.Shop>(`${this.baseURL}/api/internal/package-info/${id}/shop-image/update`, images);
    }

    fetchNames(): Observable<ShopOption[]> {
        return this.http.get<any[]>(`${this.baseURL}/api/internal/package-info/shop-search`).pipe(
            map(list => list.map(m => ({
                value: m.id,
                label: m.name,
                status: m.status
            }))),
            map(list => orderBy((list), 'label'))
        );
    }

}
